import { Link, Outlet, useParams } from 'react-router';
import { useQuery } from '@apollo/client/react';

import { SoftwareEscrowSettingsRoutesEnum } from 'src/pages/SoftwareEscrow';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { InvitationStatusEnum } from 'src/graphql/schema';
import { ClientChangesRequestedDocument } from 'src/graphql/actions/suggestChanges/clientChangesRequested.query';
import { useSoftwareEscrow } from 'src/context/software-escrow';

const Sidebar = () => {
  const { id, '*': path = '' } = useParams();
  const { data: changesRequestedData } = useQuery(ClientChangesRequestedDocument);

  const items = [
    {
      label: 'Depositor',
      value: SoftwareEscrowSettingsRoutesEnum.Depositor,
      hasChanges: Boolean(changesRequestedData?.clientChangesRequested.depositor),
    },
    {
      label: 'Beneficiary',
      value: SoftwareEscrowSettingsRoutesEnum.Beneficiary,
      hasChanges: Boolean(changesRequestedData?.clientChangesRequested.beneficiary),
    },
    {
      label: 'Technical',
      value: SoftwareEscrowSettingsRoutesEnum.Technical,
      hasChanges: Boolean(changesRequestedData?.clientChangesRequested.notifications),
    },
    {
      label: 'Agreement',
      value: SoftwareEscrowSettingsRoutesEnum.Agreement,
      hasChanges: Boolean(changesRequestedData?.clientChangesRequested.agreement),
    },
  ];

  return (
    <aside className="mb-4 md:mb-0 md:w-[292px] md:px-3 md:py-6 md:border-r">
      <ul className="flex space-y-1 md:block md:sticky top-0">
        {items.map(({ label, value, hasChanges }) => (
          <li key={value} className="relative">
            <Link
              to={`/software-escrows/${id}/settings/${value}`}
              className={cn(
                'block px-3 py-2 text-foreground! hover:bg-accent! rounded-md',
                path === value && 'bg-accent!',
              )}
            >
              {label} <span className="hidden md:inline">information</span>
            </Link>
            {hasChanges && (
              <span className="pointer-events-none absolute right-[3px] md:right-3 top-1/2 -translate-y-1/2 rounded-full bg-orange-700 size-1.5 animate-pulse" />
            )}
          </li>
        ))}
      </ul>
    </aside>
  );
};

const SettingsLayout = () => {
  const {
    softwareEscrow: { escrowInvitation },
  } = useSoftwareEscrow();

  return (
    <div className="container mx-auto">
      <Card
        className={cn('p-5 md:p-6', {
          'opacity-70 pointer-events-none': escrowInvitation?.status === InvitationStatusEnum.Rejected,
        })}
      >
        <div className="flex flex-col md:flex-row">
          <Sidebar />
          <div className="flex-1 md:p-6">
            <Outlet />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default SettingsLayout;
